import { IIconBase } from '..'

const historyExportIcon = ({
  color = '#DAF9F2',
  height = 32,
  width = 32,
}: IIconBase) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox='0 0 32 32'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <g filter='url(#filter0_ddd_5316_116602)'>
        <rect x='4' y='3' width='24' height='24' rx='12' fill={color} />
        <path
          d='M9.33334 12.6666C9.33334 10.3333 10.6667 9.33331 12.6667 9.33331H19.3333C21.3333 9.33331 22.6667 10.3333 22.6667 12.6666V17.3333C22.6667 19.6666 21.3333 20.6666 19.3333 20.6666H12.6667'
          stroke='#292D32'
          strokeWidth='1.5'
          strokeMiterlimit='10'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M19.3333 13L17.2467 14.6667C16.56 15.2133 15.4333 15.2133 14.7467 14.6667L12.6667 13'
          stroke='#292D32'
          strokeWidth='1.5'
          strokeMiterlimit='10'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M9.33334 18H13.3333'
          stroke='#292D32'
          strokeWidth='1.5'
          strokeMiterlimit='10'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M9.33334 15.3333H11.3333'
          stroke='#292D32'
          strokeWidth='1.5'
          strokeMiterlimit='10'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      </g>
      <defs>
        <filter
          id='filter0_ddd_5316_116602'
          x='0'
          y='0'
          width='32'
          height='32'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feColorMatrix
            in='SourceAlpha'
            type='matrix'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
            result='hardAlpha'
          />
          <feOffset />
          <feGaussianBlur stdDeviation='1' />
          <feColorMatrix
            type='matrix'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0'
          />
          <feBlend
            mode='normal'
            in2='BackgroundImageFix'
            result='effect1_dropShadow_5316_116602'
          />
          <feColorMatrix
            in='SourceAlpha'
            type='matrix'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
            result='hardAlpha'
          />
          <feOffset dy='1' />
          <feGaussianBlur stdDeviation='2' />
          <feColorMatrix
            type='matrix'
            values='0 0 0 0 0.272 0 0 0 0 0.294667 0 0 0 0 0.34 0 0 0 0.12 0'
          />
          <feBlend
            mode='normal'
            in2='effect1_dropShadow_5316_116602'
            result='effect2_dropShadow_5316_116602'
          />
          <feColorMatrix
            in='SourceAlpha'
            type='matrix'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
            result='hardAlpha'
          />
          <feMorphology
            radius='1'
            operator='dilate'
            in='SourceAlpha'
            result='effect3_dropShadow_5316_116602'
          />
          <feOffset />
          <feColorMatrix
            type='matrix'
            values='0 0 0 0 0.596078 0 0 0 0 0.630065 0 0 0 0 0.698039 0 0 0 0.1 0'
          />
          <feBlend
            mode='normal'
            in2='effect2_dropShadow_5316_116602'
            result='effect3_dropShadow_5316_116602'
          />
          <feBlend
            mode='normal'
            in='SourceGraphic'
            in2='effect3_dropShadow_5316_116602'
            result='shape'
          />
        </filter>
      </defs>
    </svg>
  )
}

export default historyExportIcon
